import { STEP_CONFIGS } from "@planning/config";
import {
  ProposalFormSchema,
  ProposalUIState,
  useProposalBuilderContext,
} from "@planning/providers/proposal-provider";
import { useFormContext } from "react-hook-form";
import { MultiStepFormV2Steps } from "web-design-system";
import z from "zod";
import { handleError } from "@/utils/error";
import { useSaveProposal } from "../../hooks/use-save-proposal";
import { useSaveProposalFunds } from "../../hooks/use-save-proposal-funds";

export function ProposalSteps() {
  const { uiState, goTo } = useProposalBuilderContext();

  const form = useFormContext<z.infer<typeof ProposalFormSchema>>();

  const saveProposal = useSaveProposal();
  const saveProposalFunds = useSaveProposalFunds();

  const handleGoTo = async (id: string) => {
    try {
      // Sidebar navigation can jump straight to another step, bypassing the
      // footer's save-on-continue - persist whatever the step being left
      // holds unsaved edits for, so it isn't silently lost.
      if (uiState === "setup") {
        await saveProposal();
      } else if (
        uiState === "lumpsum" ||
        uiState === "sip" ||
        uiState === "remarks"
      ) {
        await saveProposalFunds();
      }
      goTo(id as ProposalUIState);
    } catch (error) {
      handleError(error, "Failed to save changes");
    }
  };

  return (
    <MultiStepFormV2Steps
      config={STEP_CONFIGS}
      form={form}
      currentStepId={uiState}
      goTo={handleGoTo}
    />
  );
}
